//** Import Modules */
import axiosWithAuth from "../../../utils/axiosWithAuth";

export function requestGetReviewsList(businessID) {
  return axiosWithAuth().request({
    method: "get",
    url: `${process.env.REACT_APP_BE_API_URL}/api/business-reviews/getAllReviews/${businessID}`,
  });
}
